import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    height: '185px',
    background: theme.palette.common.white,
    borderRadius: '8px',
    overflow: 'hidden',
    boxShadow: theme.palette.shadow.cardBoxShadow,
    display: 'flex',
    '& a': {
      textDecoration: 'none',
      height: '100%',
    },
    '&:hover': {
      boxShadow: '0px 4px 36px rgba(0, 10, 22, 0.28)',
    },
  },
  cardWrapper: {
    height: '100%',
    width: '100%',
    display: 'flex',
    position: 'relative',
  },
  image: {
    width: '42%',
    objectFit: 'cover',
    minHeight: '190px',
    marginTop: '-1px',
    display: 'flex',
    justifyContent: 'center',
  },
  logoWrapper: {
    position: 'absolute',
    left: '-3.90625rem',
    top: '50%',
    transform: 'translateY(-50%)',
  },
  logo: {
    height: '7.8125rem',
    width: '7.8125rem',
    border: `1px solid ${theme.palette.grey.warm}`,
    padding: '1px',
    background: theme.palette.grey.warm,
    position: 'relative',
    display: 'flex',
    overflow: 'hidden',
    alignItems: 'center',
    flexShrink: 0,
    borderRadius: '50%',
    justifyContent: 'center',
    objectFit: 'cover',
  },
  cardInfo: {
    width: '58%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    position: 'relative',
    paddingLeft: '7rem',
  },
  headlineWrapper: {
    position: 'absolute',
    top: theme.spacing(4),
  },
  headline: {
    color: theme.palette.secondary.main,
  },
  dateRange: {
    '& span': {
      ...theme.typography.formTags,
      color: theme.palette.grey.dark,
      marginTop: '1rem',
      marginBottom: '0.625rem',
    },
  },
  detailsWrapper: {
    width: `-webkit-calc(100% - ${'7rem'})`,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    position: 'absolute',
    paddingRight: theme.spacing(3),
    bottom: theme.spacing(4),
    backgroundColor: 'transparent',
  },
  locationWrapper: {
    display: 'flex',
    flexFlow: 'row wrap',
  },
  field: {
    display: 'flex',
    alignItems: 'center',
    paddingRight: theme.spacing(2),
    '&>svg': {
      viewBox: '8 0 24 24',
    },
  },
  fieldText: {
    ...theme.typography.caption,
    color: theme.palette.grey.dark,
  },
  cta: {
    color: theme.palette.blue.main,
    textAlign: 'right',
    minWidth: '105px',
    paddingBottom: '2px',
  },
}))

export default useStyles
